module.exports = __webpack_public_path__ + "fonts/fa-brands-400.44893603b641fc72fb54ca1ec43ef839.eot";